import React from "react";
import { Box, Typography } from "@mui/material";
import ErrorImage from "../images/error.png";

export default (props: { errorMessage: string }) => (
  <Box sx={{ p: 6 }} textAlign="center">
    <Box margin={'2rem'}>
      <img src={ErrorImage} alt="Error" width="300" height="300" />
    </Box>
    <Typography variant="h6">{props.errorMessage}</Typography>
  </Box>
)
